import { useTranslation } from "react-i18next";
import { CATEGORIES } from "@/mocks/site";

export default function CategoryGrid() {
  const { t } = useTranslation();

  return (
    <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-4">
      {CATEGORIES.map((cat) => (
        <a
          key={cat.key}
          href={cat.url}
          target="_blank"
          rel="noopener nofollow"
          className="group overflow-hidden rounded-lg border border-background-200 bg-background-50 transition-colors hover:border-primary-300"
        >
          <div className="h-40 w-full overflow-hidden">
            <img
              src={cat.image}
              alt={`${t(`category.${cat.key}`)} — USFans Spreadsheet`}
              title={`${t(`category.${cat.key}`)} — USFans Spreadsheet`}
              className="h-full w-full object-cover object-top transition-transform duration-300 group-hover:scale-105"
              width={600}
              height={600}
            />
          </div>
          <div className="px-4 py-3">
            <div className="flex items-center justify-between">
              <span className="whitespace-nowrap text-sm font-semibold text-foreground-900">
                {t(`category.${cat.key}`)}
              </span>
              <span className="flex h-7 w-7 flex-none items-center justify-center rounded-full bg-background-100 text-foreground-500 transition-colors group-hover:bg-primary-100 group-hover:text-primary-700">
                <i className="ri-arrow-right-up-line text-sm" />
              </span>
            </div>
            <p className="mt-1.5 text-xs leading-relaxed text-foreground-600">{t(`categoryDesc.${cat.key}`)}</p>
          </div>
        </a>
      ))}
    </div>
  );
}